module.exports = __webpack_public_path__ + "static/media/archery07.259ce882.jpg";